import { Avatar, MenuItem, Select, Typography } from "@mui/material";
import { VerticalDiv } from "../widgets/utils"
import { T } from "../i18n";
import { flags } from "./header";
import { useContext } from "react";
import { State, StateContext } from "../state";
import { mobile } from "../utils/utils.";

export const Footer = () => {
  const {selectedLang, currency, setSelectedLang, setCurrency } = useContext(StateContext) as State;
  return (
    <footer>
      <div className="row container">
        <div>
          <Typography variant="h5">{T('language')}</Typography>
          <br/>
          <Select
              value={selectedLang}
              label="Language"
              className="inline-select"
              sx={{background: "whitesmoke", width: mobile ? '100%' : 220, display: 'flex', alignItems: "center", gap: "20px"}}
              onChange={(v: any) => setSelectedLang(v.target.value)}
          >
            <MenuItem value='it'>
              <Avatar src={flags.it}/> &nbsp;&nbsp;Italian
            </MenuItem>
            <MenuItem value="en">
              <Avatar src={flags.en}/> &nbsp;&nbsp;English
            </MenuItem>
          </Select>
          <br/><br/>
          <Typography variant="h5">{T('currency')}</Typography>
          <br/>
          <Select
            sx={{background: "whitesmoke", width: mobile ? '100%' : 220}}
            value={currency}
            label="Currency"
            onChange={(v:any) => setCurrency(v.target.value)}
          >
            <MenuItem value={'eur'}>Euro</MenuItem>
            <MenuItem value={'usd'}>US Dollar</MenuItem>
          </Select>
        </div>
        <div>
          <Typography variant="h5">App</Typography>
          <br/>
          <div style={{ marginLeft: '-15px'}}>
            <a href="https://apps.apple.com/it/app/outdoora/id6740998518" target="_blank">
              <img 
                width={mobile ? '100%': '220px'} src="https://static.vecteezy.com/system/resources/previews/012/871/374/non_2x/app-store-download-button-in-white-colors-download-on-the-apple-app-store-free-png.png"/>
            </a>
            <br/>
            {!mobile && <br/>}
            <a href="https://play.google.com/store/apps/details?id=com.padbike.expo" target="_blank">
              <img 
                width={mobile ? '100%': '220px'} src="https://static.vecteezy.com/system/resources/previews/012/871/364/non_2x/google-play-store-download-button-in-white-colors-download-on-the-google-play-store-free-png.png"/>
            </a>
          </div>
        </div>
        <div>
          <Typography variant="h5">{T('contact')}</Typography>
          <br/>
          <Typography><b>Whatsapp</b>: +39 3888353749</Typography>
          <Typography><b>{T('call')}</b>: +39 3888353749</Typography>
          <Typography><b>{T('write')}</b>: info@outdoora.app</Typography>
        </div>
        <div>
          <Typography variant="h5">{T('collaborate')}</Typography>
          <br/>
          <Typography><a href="/partner" style={{color: "#8ad6ff"}}>{T('as_shop')}</a></Typography>
          <Typography><a href="/partner" style={{color: "#8ad6ff"}}>{T('as_tour_operator')}</a></Typography>
          <br/><br />
          <Typography variant="h5">{T('payment_methods')}</Typography>
          <br/>
          <img  className="payment_methods_img" height="200" src="https://unblast.com/wp-content/uploads/2018/08/Credit-Card-Icons-2.jpg" style={{borderRadius: '8px'}}/>
        </div>
      </div>
    </footer>
  )
}